import React from 'react'
import { Link } from 'react-router-dom';
import { PencilIcon } from 'react-open-iconic-svg';

import Dog                         from 'services/Dog';
import { dogSearchStatePropTypes } from 'services/constants';
import { formatDate }              from 'services/utils';

import AbstractSearchableList from 'components/AbstractSearchableList';
import SearchFormComponent    from 'components/DogSearchForm';
import RemoveButton           from 'components/RemoveButton';

function ItemComponent({ item, collectionName, onRemove }) {
  function removeItem() {
    onRemove(item);
  }
  return (
    <div id={item.id} className="row border rounded pt-1 pb-1 mb-1 shadow-sm">
      <Link to={`/${collectionName}/${item.id}`} className="col-1 text-center" title="редактировать">
        <PencilIcon className="icon" viewBox="0 0 8 8" alt="редактировать" />
      </Link>
      <div className="dog col-11 col-md-8">
        <div className="breed-name">{item.breed_name}</div>
        <div className="name">
          {item.name} / <strong>{item.pedigree}</strong> / <small className="ms-2">{formatDate(item.date_of_birth)}</small>
          <small className="ms-2">{item.need_catalog ? ' /  нужен католог' : ''}</small>
        </div>
      </div>
      <RemoveButton className="col-1 btn-sm float-end ms-2" remove={removeItem} />
    </div>
  );
}


export default class Dogs extends AbstractSearchableList {

  constructor(props) {
    super(props);
    this.itemClass = Dog;
    this.itemName = 'dog';
    this.collectionName = 'dogs';
    this.collectionNameHuman = 'Собаки';
    this.Item = ItemComponent;
    this.SearchForm = SearchFormComponent;
    this.searchStatePropTypes = dogSearchStatePropTypes;
  }

}
